const DEMO_KEY = 'demo-key';
const DEMO_HEADER = 'x-demo-user';
const IGNORE_DEMO_HEADER = 'ignoreDemoHeader';

export { DEMO_KEY, DEMO_HEADER, IGNORE_DEMO_HEADER };
